import { store } from "../store/store";
import { memoirsApiInstance } from "./api";

export const initializeInterceptors = () => {
  memoirsApiInstance.client.interceptors.request.use(async (config) => {
    const auth = store.getState().auth;
    // A request may carry its own token (e.g. the admin token used to leave
    // an impersonation): keep it
    if (config.headers.Authorization) {
      return config;
    }
    if (auth?.userToken) {
      config.headers.set("Authorization", auth.userToken);
    } else {
      delete config.headers.Authorization;
    }
    return config;
  });
};
